import { useEffect, useMemo, useState } from 'react';
import { Card, CardBody, CardHeader, Col, Input, Label } from 'reactstrap';
import { Collapse } from 'reactstrap';
import { Search } from 'react-feather';
import { Filter } from 'Constant';
import { H5, Btn } from 'AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import {
	initialFilters,
	setFilters,
} from 'Features/Learning/ToolLeads/toolLeadSlice';
import { fetchToolLeadConfig } from 'Features/Learning/ToolLeads/Utils/ToolLeadUtils';
import { fetchToolLeadList, TOOL_LABELS } from '../ToolLeadUtils';

const FindToolLead = () => {
	const [isFilter, setIsFilter] = useState(true);
	const dispatch = useDispatch();
	const filters = useSelector((state) => state.ToolLead.filters);
	const tools = useSelector((state) => state.ToolLead.tools);
	const [draftFilters, setDraftFilters] = useState(filters);

	useEffect(() => {
		setDraftFilters(filters);
	}, [filters]);

	useEffect(() => {
		if (!tools?.length) {
			dispatch(fetchToolLeadConfig());
		}
	}, [dispatch, tools?.length]);

	const toolOptions = useMemo(
		() =>
			(tools || []).map((slug) => ({
				value: slug,
				label: TOOL_LABELS[slug] || slug,
			})),
		[tools]
	);

	const selectedTools = useMemo(() => {
		const raw = draftFilters['filter[tools_name]'];
		if (!raw) return [];
		const values = String(raw).split(',').filter(Boolean);
		return toolOptions.filter((opt) => values.includes(opt.value));
	}, [draftFilters, toolOptions]);

	const updateDraftFilters = (field, value) => {
		setDraftFilters((prev) => ({
			...prev,
			[field]: value,
		}));
	};

	const handleClickSearch = (e) => {
		e.preventDefault();
		const newFilters = {
			...draftFilters,
			page: 1,
		};
		dispatch(setFilters(newFilters));
		fetchToolLeadList(dispatch, newFilters);
	};

	const handleResetFilter = () => {
		const newFilters = { ...initialFilters };
		setDraftFilters(newFilters);
		dispatch(setFilters(newFilters));
		fetchToolLeadList(dispatch, newFilters);
	};

	return (
		<Col xl="12">
			<Card>
				<CardHeader>
					<H5 attrH5={{ className: 'mb-0' }}>
						<Btn
							attrBtn={{
								className: 'btn btn-link ps-0',
								onClick: () => setIsFilter(!isFilter),
								color: 'transperant',
							}}
						>
							Temukan Lead
						</Btn>
					</H5>
				</CardHeader>
				<Collapse isOpen={isFilter}>
					<CardBody className="filter-cards-view animate-chk">
						<div className="job-filter mb-4">
							<Label>Tools</Label>
							<Select
								isMulti
								isClearable
								options={toolOptions}
								value={selectedTools}
								placeholder="Pilih tools..."
								onChange={(selected) => {
									const value = selected?.length
										? selected.map((item) => item.value).join(',')
										: '';
									updateDraftFilters('filter[tools_name]', value);
								}}
							/>
						</div>

						<div className="job-filter mb-4">
							<div className="faq-form">
								<Input
									className="form-control"
									type="text"
									placeholder="Cari nama.."
									value={draftFilters['filter[name]'] || ''}
									onKeyUp={(e) => (e.key === 'Enter' ? handleClickSearch(e) : null)}
									onChange={(e) => updateDraftFilters('filter[name]', e.target.value)}
								/>
								<Search className="search-icon" />
							</div>
						</div>

						<div className="job-filter mb-4">
							<div className="faq-form">
								<Input
									className="form-control"
									type="text"
									placeholder="Cari email.."
									value={draftFilters['filter[email]'] || ''}
									onKeyUp={(e) => (e.key === 'Enter' ? handleClickSearch(e) : null)}
									onChange={(e) => updateDraftFilters('filter[email]', e.target.value)}
								/>
								<Search className="search-icon" />
							</div>
						</div>

						<div className="job-filter mb-4">
							<div className="faq-form">
								<Input
									className="form-control"
									type="text"
									placeholder="Cari WhatsApp.."
									value={draftFilters['filter[whatsapp]'] || ''}
									onKeyUp={(e) => (e.key === 'Enter' ? handleClickSearch(e) : null)}
									onChange={(e) => updateDraftFilters('filter[whatsapp]', e.target.value)}
								/>
								<Search className="search-icon" />
							</div>
						</div>

						<div className="job-filter mb-4">
							<Label for="date_from">Dari tanggal (created_at):</Label>
							<Input
								type="date"
								id="date_from"
								className="form-control"
								value={draftFilters['filter[date_from]'] || ''}
								onChange={(e) => updateDraftFilters('filter[date_from]', e.target.value)}
							/>
						</div>

						<div className="job-filter mb-4">
							<Label for="date_to">Sampai tanggal:</Label>
							<Input
								type="date"
								id="date_to"
								className="form-control"
								value={draftFilters['filter[date_to]'] || ''}
								onChange={(e) => updateDraftFilters('filter[date_to]', e.target.value)}
							/>
						</div>

						<div className="checkbox-animated mt-0">
							<Label className="d-block" htmlFor="sort_updated_desc">
								<Input
									className="radio_animated"
									id="sort_updated_desc"
									type="radio"
									name="tool_lead_sort"
									checked={draftFilters.sort === '-updated_at'}
									onChange={() => updateDraftFilters('sort', '-updated_at')}
								/>
								Update terbaru
							</Label>
							<Label className="d-block" htmlFor="sort_created_desc">
								<Input
									className="radio_animated"
									id="sort_created_desc"
									type="radio"
									name="tool_lead_sort"
									checked={draftFilters.sort === '-created_at'}
									onChange={() => updateDraftFilters('sort', '-created_at')}
								/>
								Daftar terbaru
							</Label>
							<Label className="d-block" htmlFor="sort_name_asc">
								<Input
									className="radio_animated"
									id="sort_name_asc"
									type="radio"
									name="tool_lead_sort"
									checked={draftFilters.sort === 'name'}
									onChange={() => updateDraftFilters('sort', 'name')}
								/>
								Nama A-Z
							</Label>
							<Label className="d-block" htmlFor="sort_attempts_desc">
								<Input
									className="radio_animated"
									id="sort_attempts_desc"
									type="radio"
									name="tool_lead_sort"
									checked={draftFilters.sort === '-attempts'}
									onChange={() => updateDraftFilters('sort', '-attempts')}
								/>
								Percobaan terbanyak
							</Label>
						</div>

						<div className="job-filter mb-3 mt-3">
							<Label for="per_page">Per halaman</Label>
							<Input
								type="select"
								id="per_page"
								value={draftFilters.per_page || 15}
								onChange={(e) => updateDraftFilters('per_page', Number(e.target.value))}
							>
								<option value={15}>15</option>
								<option value={50}>50</option>
								<option value={100}>100</option>
							</Input>
						</div>

						<div className="d-flex gap-2">
							<Btn attrBtn={{ color: 'primary', className: 'text-center', onClick: handleClickSearch }}>
								{Filter}
							</Btn>
							<Btn attrBtn={{ color: 'light', className: 'text-center', onClick: handleResetFilter }}>
								Reset
							</Btn>
						</div>
					</CardBody>
				</Collapse>
			</Card>
		</Col>
	);
};

export default FindToolLead;
